import { memo } from 'react';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { PointsApplicationState } from 'root/src/server/modules/points/types/types';
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription } from 'root/src/client/v2/common/components/ui/dialog';
import { Button } from 'root/src/client/v2/common/components/ui/button';
import { cn } from 'root/src/client/v2/common/helpers/cn';
const STATUS_META = {
    [ProjectStatus.ProjectDelivered]: { label: 'Completed', className: 'bg-neon-green/15 text-neon-green' },
    [ProjectStatus.ProjectAccepted]: { label: 'Accepted', className: 'bg-neon-cyan/15 text-neon-cyan' },
    [ProjectStatus.Pending]: { label: 'Accepted', className: 'bg-neon-cyan/15 text-neon-cyan' },
    [ProjectStatus.DeliveryPending]: { label: 'In review', className: 'bg-neon-amber/15 text-neon-amber' },
    [ProjectStatus.Rejected]: { label: 'Rejected', className: 'bg-destructive/15 text-destructive' },
    [ProjectStatus.DeliveryRejected]: { label: 'Rejected', className: 'bg-destructive/15 text-destructive' },
};
const POINTS_STATE_LABEL = {
    [PointsApplicationState.APPROVED]: 'Approved',
    [PointsApplicationState.REJECTED]: 'Rejected',
    [PointsApplicationState.PENDING]: 'In review',
    [PointsApplicationState.ON_HOLD]: 'On hold',
};
const Row = ({ label, value }) => (<div className="flex items-center justify-between text-sm">
		<span className="text-muted-foreground">{label}</span>
		<span className="font-medium text-foreground">{value}</span>
	</div>);
export const ParticipationDialog = memo(({ drop }) => {
    var _a, _b;
    const dares = ((_a = drop.dares) !== null && _a !== void 0 ? _a : []);
    const myDares = dares.filter(dare => Boolean(dare.status));
    if (!myDares.length && !drop.pointsApplicationState) {
        return null;
    }
    return (<Dialog>
			<DialogTrigger asChild>
				<Button variant="outline" className="mt-3 w-full rounded-lg text-xs font-semibold">Your participation</Button>
			</DialogTrigger>
			<DialogContent className="redesign max-w-md gap-0 overflow-hidden border-white/[0.08] bg-card/90 p-0 backdrop-blur-xl">
				<DialogHeader className="border-b border-solid border-white/[0.06] px-5 py-4 text-left">
					<DialogTitle className="font-display text-base font-semibold">Your participation</DialogTitle>
					<DialogDescription className="text-xs text-muted-foreground">Your dares and points for this drop.</DialogDescription>
				</DialogHeader>

				<div className="space-y-5 px-5 py-4">
					{myDares.length > 0 && (<div>
							<p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/60">Your dares ({myDares.length})</p>
							<ul className="mt-2 space-y-2">
								{myDares.map((dare) => {
                var _a, _b, _c;
                const meta = (_b = STATUS_META[(_a = dare.status) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : { label: (_c = dare.status) !== null && _c !== void 0 ? _c : '', className: 'bg-secondary text-muted-foreground' };
                return (<li key={dare.id} className="flex items-center justify-between gap-3 rounded-lg border border-solid border-white/[0.06] bg-white/[0.03] px-3 py-2">
											<span className="truncate text-sm text-foreground">{dare.title}</span>
											<span className={cn('shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold', meta.className)}>{meta.label}</span>
										</li>);
            })}
							</ul>
						</div>)}

					{drop.awardPoints && (<div>
							<p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/60">Points</p>
							<div className="mt-2 space-y-1.5">
								{drop.pointsApplicationState && (<Row label="Application" value={(_b = POINTS_STATE_LABEL[drop.pointsApplicationState]) !== null && _b !== void 0 ? _b : drop.pointsApplicationState}/>)}
								{drop.estimatedPointsToEarn ? <Row label="Estimated to earn" value={`${drop.estimatedPointsToEarn.toLocaleString()} pts`}/> : null}
							</div>
						</div>)}
				</div>
			</DialogContent>
		</Dialog>);
});
